import "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/swap-form/i18n/en.ts
var en_default = {
  "widgets.swap-form.header.swap": "Swap",
  "widgets.swap-form.input.title.you_pay": "You pay",
  "widgets.swap-form.input.title.you_receive": "You receive",
  "widgets.swap-form.input.balance.balance": "Balance",
  "widgets.swap-form.fusion-info.slippage-tolerance": "Slippage tolerance",
  "widgets.swap-form.fusion-info.auction-time": "Auction time",
  "widgets.swap-form.fusion-info.min-receive": "Minimum receive",
  "widgets.swap-form.fusion-info.net-fee": "Network Fee",
  "widgets.swap-form.swap-button.confirm-swap": "Confirm swap",
  "widgets.swap-form.swap-button.update-swap-data": "Finding swap path",
  "widgets.swap-form.swap-button.check-allowance": "Check allowance",
  "widgets.swap-form.swap-button.native-token-not-supported": "Native token not supported now",
  "widgets.swap-form.swap-button.approve-and-swap": "Approve and Swap",
  "widgets.swap-form.swap-button.permit-and-swap": "Permit and Swap",
  "widgets.swap-form.swap-button.connect-wallet": "Connect wallet",
  "widgets.swap-form.swap-button.select-source-token": "Select source token",
  "widgets.swap-form.swap-button.select-destination-token": "Select destination token",
  "widgets.swap-form.swap-button.enter-amount-to-swap": "Enter amount to swap",
  "widgets.swap-form.swap-button.no-liquidity-for-swap": "No liquidity for swap",
  "widgets.swap-form.swap-button.insufficient-balance": "Insufficient {{symbol}} balance",
  "widgets.swap-form.swap-button.set-max": "Set max {{symbol}}",
  "widgets.swap-form.swap-button.wait-wallet-response": "Wait wallet response",
  "widgets.swap-form.swap-button.permit-swap-in-wallet": "Permit swap in wallet",
  "widgets.swap-form.swap-button.allow-swap-in-wallet": "Allow swap in wallet",
  "widgets.swap-form.swap-button.wallet-rejected": "Wallet rejected request",
  "widgets.swap-form.swap-button.swap-error-message": "Swap error",
  "widgets.swap-form.swap-button.waiting-approve-transaction": "Waiting token approve"
};
export {
  en_default as default
};
//# sourceMappingURL=en-2MFTSBRT.js.map
